export const serviceWelt = 'ServiceWelt';
export const serviceWeltDemo = 'ServiceWelt Demo';
export const userManagement = 'User Management';
// Per SER-1471 AC the Toolbox link is named the same in all languages.
export const toolbox = 'Toolbox';
export const isgRegistration = 'ISG Registration';
export const deviceRegistration = 'Device Registration';
